import AmountRangPickerButton from './AmountRangPickerButton';
export default AmountRangPickerButton;
//# sourceMappingURL=index.js.map
